/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import { AuthStorage } from "../services/storage/auth.storage";

export const AuthState = {
  // Hydrated from localStorage so the store — not localStorage — is the single
  // source of truth for "is there a session". Every place that calls
  // AuthStorage.storeUser also dispatches signInSuccess, so the two stay in
  // step; starting them in step means LOGOUT_SUCCESS always transitions
  // authData from non-null to null, which is what makes the logout observable
  // to useAuthorized. See use-authorized.hook.js.
  authData: AuthStorage.getUser() ?? null,
  counts: {
    created_counter: 0,
    parsing_counter: 0,
    validated_counter: 0,
    history_counter: 0,
  },
  hp: [],
  loading: false,
  error: null,
  profile: null,
  company: null,
};

export const UIState = {
  successSnackbar: "",
  errorSnackbar: "",
  infoSnackbar: "",
  isValidationActive: false,
};
